import { render, staticRenderFns } from "./OpenserveMplsVpnMultiConnectivity.vue?vue&type=template&id=caab1764&"
import script from "./OpenserveMplsVpnMultiConnectivity.vue?vue&type=script&lang=js&"
export * from "./OpenserveMplsVpnMultiConnectivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports